<template>
  <div class="main">
    <div class="sign-up-reward">
      <div class="reward-kv">
        <img
          src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/KV.jpg"
        />
        <div class="reward-btn js-signup-reward" @click="signUpReward"></div>
      </div>

      <div class="reward-level">
        <div class="reward-level-title">
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/level-title.png"
          />
        </div>
        <div class="reward-level-items">
          <div class="row">
            <div class="reward-level-item">
              <img
                src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/level1.png"
              />
            </div>
            <div class="reward-level-item">
              <img
                src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/level2.png"
              />
            </div>
          </div>
          <div class="row">
            <div class="reward-level-item">
              <img
                src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/level3.png"
              />
            </div>
            <div class="reward-level-item">
              <img
                src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/level4.png"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="reward-benefit">
        <div class="reward-benefit-title">
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/benefit-title.png"
          />
        </div>
        <div class="reward-benefit-items">
          <div class="row">
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon1-coupon.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员专属优惠船票95折</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon2-birthday.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>生日礼券</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon3-car.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>专车抵用券</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon4-reward.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>卓越嘉奖</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon5-ship.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>尊享航线礼遇</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon6-memebership.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员月双倍积分特权</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon7-gift.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>登船纪念品</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon8-toy.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>儿童或青少年登船礼</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon9-campaign.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员专属活动</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon10-callcenter.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员服务热线</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon11-news.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员特惠资讯</span>
              </div>
            </div>
            <div class="reward-benefit-item">
              <div class="reward-benefit-item-image">
                <img
                  src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/pc-benefit-icon12-website.png"
                />
              </div>
              <div class="reward-benefit-item-text">
                <span>会员专属网站</span>
              </div>
            </div>
          </div>
        </div>
        <div class="reward-benefit-tips">
          *以上权益据 “皇家游享荟” 会员等级不同而有差异
        </div>
      </div>
      <div class="reward-signup-btn js-signup-reward">
        <div class="img-wrap" @click="signUpReward">
          <img
            src="https://resource.rcclchina.com.cn/memberCenter/pc/signUp/bottom-btn.jpg"
          />
        </div>
      </div>
      <div class="sin_container" style="text-align: center; margin-top: 20px">
        <p>如需查看皇冠铁锚俱乐部相关信息，请登录后查看。</p>
      </div>
    </div>

    <!-- 弹层 -->
    <sign-up-reward-confirm
      ref="sign"
      @on-cancel="handleCancel"
      @on-confirm="handleConfirm"
    ></sign-up-reward-confirm>
  </div>
</template>

<script>
import SignUpRewardConfirm from "@/components/User/SignUpRewardConfirm";
import api from "@/api";
import { gioTracking } from "@/utilities/tools";
export default {
  name: "SignUpReward",
  components: {
    SignUpRewardConfirm,
  },
  data: () => {
    return {};
  },
  beforeMount() {
    this.init();
  },
  methods: {
    async init() {
      this.$loading.show();
      await this.initPage();
      this.$loading.hide();
    },
    async initPage() {
      const userToken = this.$store.state.user.userToken;
      if (!userToken) {
        this.$router.push(
          `/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(
            window.location.pathname
          )}`
        );
        return false;
      }
      const userInfo = this.$store.state.user.userInfo;
      if (userInfo.userIdentity == 1) {
        return this.redirect(userInfo.localRewardToken);
      }
    },
    signUpReward() {
      this.$refs["sign"].show();
    },
    handleCancel() {},
    async handleConfirm() {
      this.$loading.show();
      const { data } = await api.user.getUserInfo();
      if (data) {
        this.$store.commit("SET_USER_INFO", { userInfo: data });
      }
      this.$loading.hide();
			this.gioHandler();
      return this.redirect(data.localRewardToken);
    },
		gioHandler () {
			let sUrl = 'nil';
			const query = this.$router.currentRoute.query;
			if (query.returnUrl &&
        query.returnUrl.length > 0) {
					sUrl = sUrl = decodeURIComponent(query.returnUrl)
				}
			gioTracking('track', 'evt_Login', {
          isMkt: 'nil',
          isNewLR: '1',
          isNewLRMkt: '1',
          sUrl,
          regUrl: location.href,
          isQR:0
        })
		},
    redirect(localRewardToken) {
      const query = this.$router.currentRoute.query;
      let returnUrl = `${process.env.VUE_APP_REWARD_URL}/rewardpc`;
      if (
        query.returnUrl &&
        query.returnUrl.length > 0 &&
        query.returnUrl.toLowerCase().indexOf("signupreward") < 0
      ) {
        returnUrl = query.returnUrl;
      }

      if (localRewardToken) {
        if (localRewardToken) {
          if (returnUrl.indexOf("?") > 0) {
            returnUrl += `&token=${localRewardToken}`;
          } else {
            returnUrl += `?token=${localRewardToken}`;
          }
        }
      }
      location.href = returnUrl;
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
  },
  watch: {
    userInfo(newValue) {
      console.log(newValue);
      if (newValue && newValue.userIdentity > 0) {
        return this.redirect(newValue.localRewardToken);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.sign-up-reward {
  padding-bottom: 77px;
  img {
    display: block;
    width: 100%;
  }
  .reward-kv {
    position: relative;
    width: 100%;
    .reward-btn {
      position: absolute;
      width: 23.68%;
      height: 17%;
      top: 60%;
      left: 38.16%;
      cursor: pointer;
      z-index: 1;
    }
  }
  .reward-level {
    margin-top: 50px;
    .reward-level-title {
      width: 576px;
      margin: auto;
    }
    .reward-level-items {
      margin-top: 42px;
      .row {
        margin: 0 auto;
        padding: 0;
        width: 957px;
        &:first-child {
          margin-bottom: 10px;
        }
        &::after {
          content: "";
          clear: both;
        }
        .reward-level-item {
          float: left;
          width: 473px;
          &:first-child {
            margin-right: 10px;
          }
        }
      }
    }
  }
  .reward-benefit {
    position: relative;
    margin-top: 75px;
    .reward-benefit-title {
      width: 576px;
      margin: auto;
    }
    .reward-benefit-items {
      position: relative;
      margin: 55px auto 0 auto;
      width: 958px;
      .row {
        margin: 0;
        padding: 0;
        &:first-child {
          margin-bottom: 48px;
        }
        &::after {
          content: "";
          clear: both;
        }
        .reward-benefit-item {
          float: left;
          width: 109px;
          margin-left: 60px;
          text-align: center;
          color: #495258;
          font-size: 16px;
          &:first-child {
            margin-left: 0px;
          }
          .reward-benefit-item-image {
            width: 100%;
          }
          .reward-benefit-item-text {
            margin-top: 15px;
            font-weight: 400;
          }
        }
      }
    }
    .reward-benefit-tips {
      width: 958px;
      margin: 20px auto 0 auto;
      text-align: right;
      font-size: 14px;
      color: #747d80;
      letter-spacing: 1px;
    }
  }
  .reward-signup-btn {
    width: 447px;
    margin: 80px auto 0 auto;
    cursor: pointer;
  }
}
.sin_container {
  .input__top {
    &.isRegisterMember {
      img {
        &:nth-child(1) {
          display: none;
        }
        &:nth-child(2) {
          display: inline-block;
        }
      }
      &.active {
        img {
          &:nth-child(1) {
            display: inline-block;
          }
          &:nth-child(2) {
            display: none;
          }
        }
      }
    }
  }
}
</style>
